import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TerminalAbortService {
  private abortFn: (() => Observable<boolean>) | null = null;

  register(fn: () => Observable<boolean>): void {
    this.abortFn = fn;
  }

  unregister(): void {
    this.abortFn = null;
  }

  abortIfNeeded$(): Observable<boolean> | null {
    return this.abortFn ? this.abortFn() : null;
  }
}
